import { gsap } from "gsap";
export default {
    bind(el, binding) {
        const {  duration = 0.3, ...otherOptions } = binding.value || {};

        // 保存元素的初始样式
        el._originalStyle = {
            transform: el.style.transform
        };

        el._hoverScale = () => {
            gsap.to(el, { duration, ...otherOptions });
        };
        el._hoverScaleReset = () => {
            gsap.to(el, { scale: 1, duration, onComplete: () => {
                    // 恢复元素的初始样式
                    el.style.transform = el._originalStyle.transform;
                } });
        };
        el.addEventListener('mouseenter', el._hoverScale);
        el.addEventListener('mouseleave', el._hoverScaleReset);
    },
    unbind(el) {
        el.removeEventListener('mouseenter', el._hoverScale);
        el.removeEventListener('mouseleave', el._hoverScaleReset);
    }
};


